export const LinkData = [
    {
        id: 1,
        title: "Home",
        url: "/",
    },
    {
        id: 2,
        title: "KuppiRecordings",
        url: "/youtube",
    },
    {
        id: 3,
        title: "Uni Notes",
        url: "/notes",
    },
    {
        id: 4,
        title: "Tuition Classes",
        url: "/profile",
    },
    {
      id: 5,
      title: "O/L Api",
      url: "/ol-folder",
    },
    {
      id: 6,
      title: "A/L Api",
      url: "/al-folder",
    },
    {
      id: 7,
      title: "Job Market",
      url: "/jobs",
    },
    {
      id: 8,
      title: "Bodim",
      url: "/booking",
    }
]
export const courses = [
    {
        id: 1,
        title: "Geography",
        instructor: 'Asiri Devendra',
        count: '5',
        imageUrl: 'https://roflmagnets.com/320-home_default/a-letter.jpg',
        coverUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQowSj_JJ9DJYpCWmoZfKgEq5sPwJkkLsKD2w&s'
    },
    {
        id: 1,
        title: "Econ",
        instructor: 'Asiri Devendra',
        count: '15',
        imageUrl: 'https://roflmagnets.com/320-home_default/a-letter.jpg',
        coverUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTXHP03vPwC7Bnw5Cr6ZLnQNm9gc2Zvyam1cQ&s'
    }
]

export const blog = [
    {
        id: 1,
        title: "ජපුර සීගිරි විචිත්‍රා 2023",
        category:'Archeological Exploration',
        hostName:'',  
        hostProfilePicUrl:'https://roflmagnets.com/320-home_default/a-letter.jpg',
        videoUrl: 'https://youtu.be/YDvYjw8x7r8?si=f9aOsD6kgplphqMq'
    },
    {
        id: 2,
        title: "Campus කියන්නේ Online ලෙක්චර්ස් විතරක් ම නෙවෙයි",
        date:'Feb 1, 2023',
        category:'ජපුර සීගිරි විචිත්‍රා',
        hostName:'',
        hostProfilePicUrl:'https://roflmagnets.com/320-home_default/a-letter.jpg',
        videoUrl: 'https://youtu.be/ThLMPrAtyoM?si=iGnX49kYy_1Zg-eK'
    },
]

export const videos = [ 
    {
        id: 1,
        title: "ARGE කුප්පිය | EP 01 | 3002 අනුරාධපුර ස්තූපවල වාස්තු විද්‍යාත්මක බව",
        subject:'ARGE',
        url: 'https://youtu.be/EkBPf_9FEpU?si=WgkvxBVFAWdmlUIU',
    },
    {
        id: 2,
        title: "GEGE FINAL (1ST YEAR & Repeat)",
        subject:'GEGE',
        url: 'https://www.youtube.com/live/9yHpQXCEOcQ?si=pLf-Jf-qUxz5N2EC',
    },
    {
        id: 3,
        title: "SIGE 2002 | EP 01 | 2ND YEAR",
        subject:'SIGE',
        url: 'https://youtu.be/o9LWQYttIzY?si=MEsuREt0b9rb_RdN',
    },
    {
        id: 4,
        title: "EP 07- ආසියන් සංවිධානය හා යුරෝපීය හවුල|1002- IR KUPPIYA",
        subject:'IR',
        url: 'https://youtu.be/m8AtOjEUqtw?si=FgMfw9xcZCqC-Yy7',
    }
]


export const data = [
    {
      id: 1,
      image:'',
      name: 'maria ferguson',
      title: 'office manager',
      quote:
        'Fingerstache umami squid, kinfolk subway tile selvage tumblr man braid viral kombucha gentrify fanny pack raclette pok pok mustache.',
    },
    {
      id: 2,
      image:
        '../images/Slide2.jpg',
      name: 'john doe',
      title: 'regular guy',
      quote:
        'Gastropub sustainable tousled prism occupy. Viral XOXO roof party brunch actually, chambray listicle microdosing put a bird on it paleo subway tile squid umami.',
    },
    {
      id: 3,
      image:
        '../images/Slide3.jpg',
      name: 'peter smith',
      title: 'product designer',
      quote:
        'Drinking vinegar polaroid street art echo park, actually semiotics next level butcher master cleanse hammock flexitarian ethical paleo.',
    },
    {
      id: 4,
      image:
        '../images/Slide4.jpg',
      name: 'susan andersen',
      title: 'the boss',
      quote:
        'Marfa af yr 3 wolf moon kogi, readymade distillery asymmetrical seitan kale chips fingerstache cloud bread mustache twee messenger bag. ',
    },
  ];


 export const products = [
    {
      id: 1,
      name: "Wireless Headphones",
      price: 99.99,
      image: "https://media.wired.com/photos/66abec9ccb172c2e5de763bf/master/w_960,c_limit/Edifier-Stax-Spirit-S5-Headphones-Offwhite-Background-SOURCE-Amazon.jpg/200x200"
    },
    {
      id: 2,
      name: "Bluetooth Speaker",
      price: 49.99,
      image: "https://cdn.thewirecutter.com/wp-content/media/2024/11/portablebluetoothspeakers-2048px-9481.jpg?auto=webp&quality=75&width=1024"
    },
    {
      id: 3,
      name: "Smart Watch",
      price: 199.99,
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQnxRQxEjDRh4Jo7GF6OdjyrB-3ePtkTzUtUQ&s"
    },
    {
      id: 4,
      name: "Laptop Backpack",
      price: 39.99,
      image: "https://api.gqmobiles.lk/wp-content/uploads/2025/01/gq-mobiles-lenovo-laptop-backpack-b210-6.png"
    },
    {
      id: 5,
      name: "Wireless Mouse",
      price: 29.99,
      image: "https://images.monoprice.com/productlargeimages/440281.jpg"
    },
    {
      id: 6,
      name: "USB-C Hub",
      price: 59.99,
      image: "https://cdn.sandberg.world/products/images/lg/136-41_lg.jpg"
    }
  ];
  export const newsData = [
  {
    id: 1,
    title: "Breaking News 1",
    excerpt: "Short description for news item 1...",
    image: "https://picsum.photos/800/400?random=1",
    content: "Full content for news article 1...",
  },
  {
    id: 2,
    title: "Important Update 2",
    excerpt: "Short description for news item 2...",
    image: "https://picsum.photos/800/400?random=2",
    content: "Full content for news article 2...",
  },
];
